module.exports = __webpack_public_path__ + "img/twitter.a01af120.svg";